import routerOptions0 from "/opt/atlassian/pipelines/agent/build/yvr.portal/portal/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}